// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/modules/es7.math.scale.js
// module id = 563
// module chunks = 0